import { createContext, useContext, useState } from "react";

export interface ActiveSlideDefinition {
    activeSlide: number;
    setActiveSlide: (activeSlide) => void;
}

const defaults: ActiveSlideDefinition = {
    activeSlide: 0, 
    setActiveSlide: () => {return}
}

export const ActiveSlideContext = createContext<ActiveSlideDefinition>(defaults);

export default function ActiveSlideProvider({ children }) {
    const [activeSlide, setActiveSlide] = useState(defaults.activeSlide);
       
    return (
        <ActiveSlideContext.Provider value={{activeSlide, setActiveSlide}}>
            {children}
        </ActiveSlideContext.Provider>
    ); 
}

export function useActiveSlide() {
    const { activeSlide, setActiveSlide } = useContext(ActiveSlideContext);
    return { activeSlide, setActiveSlide };
}